<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Datacenter Master</mat-card-title>
    <button mat-fab (click)="openDialog()" color="accent"
      style="position:absolute;right:10px;top:8px;width:35px; height:35px;" matTooltip="Add Datacenter">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">add</i>
      </span>
    </button>
    <button mat-fab (click)="downloadAllRecords()" color="accent"
      style="position:absolute; right:50px;top:8px;width:35px; height:35px;"
      *ngIf="Warehouses != null && Warehouses.length >0" matTooltip="Download Records">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">download</i>
      </span>
    </button>
    <mat-card-subtitle></mat-card-subtitle>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9">
      </div>
      <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
         <app-filter-input *ngIf="Warehouses!=null && Warehouses.length >0" (filterChanged)="applyFilter($event)"></app-filter-input>
      </div>
    </div>
    <mat-card-content>
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
          (matSortChange)="announceSortChange($event)" *ngIf="Warehouses!=null && Warehouses.length >0"  
          aria-label="Table listing datacenters">
          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef>S No. </th>
            <td mat-cell *matCellDef="let element; let i = index;"> 
              {{ (i + 1) + (pageEvent?.pageSize * pageEvent?.pageIndex) }}
            </td>
          </ng-container>

          <!-- warehouseId Column -->
          <ng-container matColumnDef="warehouseId">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element"> {{element.warehouseId}} </td>
          </ng-container>
          <!-- warehouseName Column -->
          <ng-container matColumnDef="warehouseName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Datacenter">
              Datacenter
            </th>
            <td mat-cell *matCellDef="let element"> {{element.warehouseName}} </td>
          </ng-container>

          <!-- description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by description">
              Description
            </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
          </ng-container>

          <!-- stateId Column -->
          <ng-container matColumnDef="stateId">
            <th mat-header-cell> stateId</th>
            <td mat-cell *matCellDef="let element"> {{element.stateId}} </td>
          </ng-container>
          <!-- stateName Column -->
          <ng-container matColumnDef="stateName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by stateName"> State </th>
            <td mat-cell *matCellDef="let element"> {{element.stateName}} </td>
          </ng-container>

          <!-- cityId Column -->
          <ng-container matColumnDef="cityId">
            <th mat-header-cell> </th>
            <td mat-cell *matCellDef="let element"> {{element.cityId}} </td>
          </ng-container>
          <!-- cityId Column -->
          <ng-container matColumnDef="cityName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by cityName"> City </th>
            <td mat-cell *matCellDef="let element"> {{element.cityName}} </td>
          </ng-container>



          <!-- warehouseManagerId:  Column -->
          <ng-container matColumnDef="warehouseManager">
            <th mat-header-cell *matHeaderCellDef> Manager </th>
            <td mat-cell *matCellDef="let element"> {{element.warehouseManager }} </td>
          </ng-container>

          <!-- address  Column -->
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef> Address </th>
            <td mat-cell *matCellDef="let element"> {{element.address }} </td>
          </ng-container>

          <!-- isActive Column -->
          <ng-container matColumnDef="isActive">
            <th mat-header-cell> Active </th>
            <td mat-cell *matCellDef="let element"> {{element.isActive}} </td>
          </ng-container>

          <!-- isDeleted Column -->
          <ng-container matColumnDef="isDeleted">
            <th mat-header-cell> Deleted </th>
            <td mat-cell *matCellDef="let element"> {{element.isDeleted}} </td>
          </ng-container>


          <!-- createdBy Column -->
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef> CreatedBy </th>
            <td mat-cell *matCellDef="let element"> {{element.createdBy}} </td>
          </ng-container>

          <!-- createdOn Column -->
          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by createdOn"> createdOn
            </th>
            <td mat-cell *matCellDef="let element"> {{element.createdOn}} </td>
          </ng-container>


          <!-- updatedBy Column -->
          <ng-container matColumnDef="updatedBy">
            <th mat-header-cell *matHeaderCellDef> UpdatedBy </th>
            <td mat-cell *matCellDef="let element"> {{element.updatedBy}} </td>
          </ng-container>

          <!-- updatedOn Column -->
          <ng-container matColumnDef="updatedOn">
            <th mat-header-cell *matHeaderCellDef> UpdatedOn </th>
            <td mat-cell *matCellDef="let element"> {{element.updatedOn}} </td>
          </ng-container>

          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef> Edit </th>
            <td mat-cell *matCellDef="let element">
              <button mat-mini-fab aria-label="Delete" (click)="updateHouse($event, element)">
                <mat-icon>create</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef> Delete </th>
            <td mat-cell *matCellDef="let element">
              <button mat-mini-fab aria-label="Delete" (click)="softdelete($event, element)" color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <mat-paginator
      [length]="totalRows"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event; pageChanged($event)">
    </mat-paginator>
      <div *ngIf="isLoaderResult" class="custSpinner">
      </div>
    </mat-card-content>
  </mat-card>
</div>